<template>
    <div
        id="avaliacoes-list-item"
        :class="{ rated: productData.note }"
        @mouseenter="hoverCard(true)"
        @mouseleave="hoverCard(false)"
    >
        <div id="item-image-wrapper" :class="{ rated: productData.note }">
            <img
                :src="`${productData.image}?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`"
            />
        </div>
        <div id="item-content">
            <div id="item-details">
                <span id="title" class="text-uppercase">{{ productData.product_name }}</span>
            </div>
            <AvaliacoesShowStars
                :show-only-selected="hideUnselectedStars"
                :stars-rating="starCount"
            />
            <div id="item-rated" class="d-flex" v-if="productData.note">
                <span class="text-uppercase">Avaliado</span>
                <i class="icon-cr icon-btn-selected" />
            </div>
        </div>

        <transition name="fade" mode="out-in">
            <div
                id="item-hover"
                class="d-flex flex-align-center"
                v-if="hoverState && !productData.note"
            >
                <router-link
                    :to="{
                        name: 'form',
                        params: { productId: productData.product_id },
                        query: $route.query,
                    }"
                >
                    <button id="btn-hover" class="btn">Avaliar</button>
                </router-link>
            </div>
        </transition>
    </div>
</template>

<script>
    import AvaliacoesShowStars from './AvaliacoesShowStars.vue';

    export default {
        name: 'AvaliacoesListItem',
        components: { AvaliacoesShowStars },

        props: {
            productData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                hoverState: false,
                hideUnselectedStars: true,
                starCount: 0,
            };
        },

        beforeMount() {
            this.checkStarSelection();
        },

        methods: {
            hoverCard(state) {
                this.hoverState = state;
            },

            checkStarSelection() {
                this.starCount = this.productData.note !== null ? this.productData.note : 0;
                this.hideUnselectedStars = this.starCount !== 0;
            },
        },
    };
</script>
